import React, { createContext, useContext, useState } from 'react';
import enJson from '../locales/en.json';
import ptJson from '../locales/pt.json';
import esJson from '../locales/es.json';

/* desativado
// EN translations
const enTranslations = {
  common: {
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    confirm: "Confirmar",
    save: "Salvar",
    edit: "Editar",
    delete: "Excluir",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    search: "Pesquisar",
    filter: "Filtrar",
    clear: "Limpar",
    select: "Selecionar",
    all: "Todos",
    none: "Nenhum",
    yes: "Sim",
    no: "Não",
    tryAgain: "Tentar Novamente",
    continue: "Continuar",
    finish: "Finalizar"
  },
  navigation: {
    home: "Início",
    reservations: "Reservas",
    clients: "Clientes",
    services: "Serviços",
    reports: "Relatórios",
    settings: "Configurações",
    profile: "Perfil",
    logout: "Sair"
  },
  settings: {
    title: "Configurações",
    theme: "Tema",
    language: "Idioma",
    lightMode: "Modo Claro",
    darkMode: "Modo Escuro",
    preferences: "Preferências",
    account: "Conta",
    notifications: "Notificações",
    privacy: "Privacidade",
    security: "Segurança"
  },
  auth: {
    login: "Entrar",
    logout: "Sair",
    register: "Cadastrar",
    newAccount: "Nova Conta",
    resetPassword: "Redefinir Senha",
    resetPasswordInstructions: "Digite seu email para receber um link de redefinição de senha",
    // {|INICIO| 23/07/2026 às 02:58 - ETAPA 7: ALINHAR MENSAGENS DE RESET COM RESPOSTA NEUTRA E TTL 30 MIN}
    resetPasswordNote: "Se existir uma conta para este e-mail, enviaremos um link de redefinição válido por 30 minutos.",
    fullName: "Nome Completo",
    enterFullName: "Digite seu nome completo",
    cpf: "CPF",
    cpfPlaceholder: "000.000.000-00",
    birthDate: "Data de Nascimento",
    cellPhone: "Celular",
    phonePlaceholder: "(11) 99999-9999",
    email: "Email",
    enterEmail: "seu@email.com",
    password: "Senha",
    enterPassword: "Digite sua senha",
    processing: "Processando...",
    sending: "Enviando...",
    send: "Enviar",
    noAccount: "Não tem conta? Cadastre-se",
    hasAccount: "Já tem conta? Faça login",
    forgotPassword: "Esqueceu sua senha?",
    emailSentSuccess: "Solicitação recebida com sucesso!",
    checkInboxSpam: "Verifique sua caixa de entrada e pasta de spam. O link expira em 30 minutos.",
    // {|FIM| 23/07/2026 às 02:58 - ETAPA 7: ALINHAR MENSAGENS DE RESET COM RESPOSTA NEUTRA E TTL 30 MIN}
    emailRequired: "O e-mail é obrigatório",
    passwordRequired: "A senha é obrigatória",
    enterEmailToReset: "Digite seu e-mail para resetar a senha",
    checkEmailForReset: "Verifique seu e-mail para obter mais informações sobre o reset de senha.",
    loginSuccessful: "Login realizado com sucesso!",
    loginFailed: "Erro ao fazer login",
    resetPasswordFailed: "Erro ao enviar reset de senha",
    emailPlaceholder: "Seu e-mail",
    passwordPlaceholder: "Sua senha",
    loggingIn: "Entrando...",
    newPassword: "Nova Senha",
    confirmNewPassword: "Confirmar Nova Senha",
    enterNewPassword: "Digite sua nova senha",
    enterNewPasswordBelow: "Digite sua nova senha abaixo",
    passwordStrength: "Força da senha",
    passwordRequirements: "Requisitos da senha",
    passwordMinLength: "Pelo menos 8 caracteres",
    passwordUpperCase: "Uma letra maiúscula",
    passwordLowerCase: "Uma letra minúscula",
    passwordNumber: "Um número",
    passwordsDoNotMatch: "As senhas não coincidem",
    passwordChangedSuccess: "Senha alterada com sucesso!",
    passwordChangeError: "Erro ao alterar senha!",
    requestProcessingError: "Erro ao processar solicitação",
    tokenNotFound: "Token não encontrado!",
    tokenInvalidOrExpired: "Token inválido ou expirado! Solicite um novo reset de senha.",
    tokenVerificationError: "Erro ao verificar token. Tente novamente.",
    verifyingToken: "Verificando token...",
    invalidToken: "Token Inválido",
    backToLogin: "Voltar ao Login",
    enterEmailForReset: "Por favor, insira seu e-mail para recuperar a senha"
  },
  terms: {
    title: "Termo de Responsabilidade",
    loadError: "Erro ao carregar o termo de responsabilidade",
    mustAcceptToContinue: "Você deve marcar que leu e aceita o termo para continuar",
    acceptError: "Erro ao aceitar termos",
    loading: "Carregando termo de responsabilidade...",
    downloadPdf: "Baixar PDF",
    acceptanceText: "Li e aceito integralmente o <strong>Termo de Responsabilidade</strong> do {companyName}, estando ciente de todos os riscos, obrigações e condições estabelecidas.",
    accepting: "Aceitando...",
    acceptAndContinue: "Aceitar e Continuar",
    mandatory: "Termo de Responsabilidade Obrigatório",
    requiredForPayment: "Para prosseguir com o pagamento, é necessário aceitar o termo de responsabilidade atualizado do KGV.",
    updatedAcceptanceRequired: "É necessário aceitar o termo de responsabilidade atualizado para prosseguir com o pagamento."
  },
  examples: {
    changePasswordExample: "Exemplo de Troca de Senha",
    enterClientId: "Informe o ID do Cliente",
    clientId: "ID do Cliente",
    enterClientIdPlaceholder: "Digite o ID do cliente",
    clientIdRequired: "Por favor, informe o ID do cliente",
    invalidClientId: "ID do cliente inválido",
    passwordChangedSuccess: "Senha alterada com sucesso!",
    clientIdLabel: "Cliente ID"
  },
  registration: {
    fullName: "Nome Completo",
    enterFullName: "Digite seu nome completo",
    email: "Email",
    enterEmail: "Digite seu email",
    birthDate: "Data de Nascimento",
    cellPhone: "Telefone Celular",
    enterPhone: "Digite seu telefone",
    register: "Cadastrar",
    registering: "Cadastrando...",
    fullNameRequired: "Informe o nome completo (nome e sobrenome). Evite abreviações.",
    invalidCpf: "O CPF informado é inválido!",
    invalidEmail: "Por favor, insira um email válido.",
    birthDateRequired: "A data de nascimento é obrigatória.",
    invalidPhone: "Informe um número de celular válido. Para números brasileiros: (11) 91234-5678. Para números internacionais: +55 11 91234-5678",
    country: "País",
    selectCountry: "Selecione seu país",
    cpf: "CPF",
    passport: "Passaporte",
    enterCpf: "Digite seu CPF",
    enterPassport: "Digite seu número de passaporte",
    invalidPassport: "Número de passaporte inválido"
  },
  profile: {
    header: "MEU CADASTRO",
    identification: "Identificação",
    id: "ID",
    clientType: "Tipo Cliente",
    consumerFinal: "Consumidor Final",
    other: "Outro",
    origin: "Origem",
    notProvided: "Não informado",
    personalDataProtected: "Dados Pessoais (Protegidos)",
    securityNote: "Os campos Nome, País, CPF/Passaporte e Email não podem ser alterados por questões de segurança.",
    name: "Nome",
    country: "País",
    cpf: "CPF",
    passport: "Passaporte",
    email: "Email",
    birthDate: "Data de Nascimento",
    rg: "RG",
    gender: "Sexo",
    genderMale: "Masculino",
    genderFemale: "Feminino",
    genderOther: "Outro",
    contactEditable: "Contato (Editável)",
    mobilePhone: "Telefone Celular",
    homePhone: "Telefone Residencial",
    workPhone: "Telefone Comercial",
    guardianDataMinor: "Dados do Responsável (Menor de Idade)",
    guardianName: "Nome do Responsável",
    guardianCpf: "CPF do Responsável",
    guardianPhone: "Telefone do Responsável",
    addressEditable: "Endereço (Editável)",
    zipCode: "CEP",
    address: "Endereço",
    number: "Número",
    complement: "Complemento",
    neighborhood: "Bairro",
    state: "Estado",
    city: "Cidade",
    saveChanges: "Salvar Alterações",
    editProfile: "Editar Perfil",
    updateSuccess: "Perfil atualizado com sucesso!",
    updateError: "Erro ao salvar perfil. Tente novamente.",
    protectedField: "Campo protegido - não pode ser alterado",
    protectedByRegistration: "Campo protegido - definido pelo cadastro",
    typeZipToSearch: "Digite o CEP para buscar automaticamente o endereço"
  },
  app: {
    title: "{companyName}",
    subtitle: "Sistema de Reservas Online",
    welcome: "Bem-vindo",
    myReservations: "Minhas Reservas",
    changePassword: "Alterar Senha",
    loading: "Carregando...",
    noReservationsFound: "Nenhuma reserva encontrada nesta categoria",
    people: "Pessoas",
    type: "Tipo",
    location: "Locação",
    time: "Horário",
    value: "Valor Pago",
    date: "Data",
    individual: "Individual",
    group: "Grupo",
    payNow: "Pagar Agora",
    manageParticipants: "Gerenciar Participantes",
    cancel: "Cancelar",
    cancelled: "Canceladas",
    paid: "Pago",
    pending: "Pendente",
    failed: "Falhou",
    canceled: "Cancelado",
    accountSigned: "Conta Assinada",
    openBatteries: "Baterias Abertas",
    closedBatteries: "Baterias Fechadas",
    viewDetails: "Ver Detalhes",
    acceptTerms: "Aceitar Termos",
    cancelReservation: "Cancelar Reserva",
    consultPoints: "Consultar Pontos",
    newRegistration: "Novo Cadastro",
    myProfile: "Meu Perfil",
    selectDate: "Selecionar Data",
    availableSlots: "Horários Disponíveis",
    noCharge: "Sem cobrança",
    organizerOnly: "Opção disponível apenas para organizadores",
    // Added missing keys for toasts and status
    success: "Sucesso",
    error: "Erro",
    processing: "Processando",
    reservationCanceled: "Reserva cancelada com sucesso!",
    terms: {
      mandatoryAcceptance: "Aceite Obrigatório do Termo de Responsabilidade",
      acceptanceRequired: "Para prosseguir com sua reserva, é necessário ler e aceitar o termo de responsabilidade do {companyName}. O termo é válido por {days} dias.",
      readFullTerm: "Ler Termo Completo"
    },
    contactForOrganizerPermissions: "Entre em contato para solicitar permissões de organizador",
    noSlotsAvailable: "Nenhum horário disponível para esta data",
    loginRequired: "É necessário fazer login para reservar",
    loginToReserve: "Para reservar, faça login",
    slotUnavailable: "Horário indisponível",
    reserve: "Reservar",
    points: "Pontos",
    expiresOn: "Expira em",
    remainingDays: "Dias Restantes",
    total: "TOTAL",
    noPointsAvailable: "Nenhum ponto disponível para exibir.",
    loadingPoints: "Carregando...",
    userNotFound: "Usuário não encontrado. Faça login novamente.",
    pointsLoadError: "Erro ao carregar extrato de pontos. Tente novamente.",
    currentPasswordRequired: "A senha atual é obrigatória",
    newPasswordRequired: "A nova senha é obrigatória",
    passwordsDoNotMatch: "A nova senha e a confirmação não conferem",
    passwordMinLength: "A nova senha deve ter pelo menos 6 caracteres",
    changePasswordError: "Erro ao trocar senha",
    currentPassword: "Senha Atual",
    newPassword: "Nova Senha",
    confirmNewPassword: "Confirmar Nova Senha",
    changing: "Alterando...",
    generating: "Gerando...",
    generate: "Gerar",
    status: {
      disponível: "Disponível",
      indisponível: "Indisponível",
      ocupado: "Ocupado",
      reservado: "Reservado"
    },
    slots: "VAGAS",
    reservationNumber: "Reserva #{id}",
    unitValueLabel: "Valor Unit.",
    totalLabel: "Total",
    updatingStatus: "Atualizando status...",
    retryPayment: "Fazer Novo Pagamento",
    cancelConfirmTitle: "Confirmar Cancelamento",
    cancelIrreversibleNote: "Esta ação é irreversível",
    cancelReservationQuestion: "Tem certeza que deseja cancelar esta reserva?",
    cancelPolicyTitle: "Política de Cancelamento",
    cancelPolicyDescription: "O cancelamento será processado conforme as políticas do KGV. Para dúvidas sobre reembolso, entre em contato pelo {phone}."
  },
  calendar: {
    selectDate: "Selecionar Data",
    timeExpired: "Horário já passou",
    months: {
      january: "Janeiro",
      february: "Fevereiro",
      march: "Março",
      april: "Abril",
      may: "Maio",
      june: "Junho",
      july: "Julho",
      august: "Agosto",
      september: "Setembro",
      october: "Outubro",
      november: "Novembro",
      december: "Dezembro"
    },
    days: {
      sunday: "Dom",
      monday: "Seg",
      tuesday: "Ter",
      wednesday: "Qua",
      thursday: "Qui",
      friday: "Sex",
      saturday: "Sáb"
    },
    selected: "Selecionado",
    unavailable: "Indisponível"
  },
  participants: {
    title: "Participantes",
    generateInvitesNoPayment: "Gerar Convites (Sem Pagamento)",
    generateNewInvites: "Gerar Novos Convites",
    noPaymentNote: "Os participantes farão apenas cadastro + aceite de termo. Sem cobrança no momento.",
    quantity: "Quantidade",
    awaitingRegistration: "Aguardando cadastro",
    emailNotProvided: "Email não informado",
    value: "Valor",
    status: "Status",
    method: "Método",
    inviteExpires: "Convite expira",
    notDefined: "Não definido",
    errorLoadingParticipants: "Erro ao carregar participantes",
    errorGeneratingInvites: "Erro ao gerar convites",
    onlyOrganizersCanProcess: "Apenas organizadores podem processar conta assinada",
    errorProcessingSignedAccount: "Erro ao processar conta assinada"
  },
  invite: {
    headerTitle: "Convite",
    headerSubtitle: "Complete o cadastro, aceite o termo e prossiga para o pagamento.",
    organizerInviteTitle: "Convite do Organizador",
    inviteTitle: "Convite para Pagamento",
    noChargeNote: "Como organizador, esta reserva é processada como conta assinada. Sem cobrança no momento.",
    registrationCompleteTitle: "Cadastro concluído",
    registrationSuccessHeading: "Cadastro realizado com sucesso!",
    registrationSuccessBody: "Você já concluiu as etapas necessárias. Caso necessário, entre em contato com o organizador.",
    registrationNoChargeNote: "Para esta reserva, não há cobrança no momento.",
    invalidOrExpired: "Convite inválido ou expirado."
  },
  payment: {
    title: "Pagamento",
    chooseMethod: "Escolha a forma de pagamento",
    payWithPix: "Pagar com PIX",
    payWithCard: "Pagar com Cartão",
    processing: "Processando pagamento",
    base: "Valor base",
    processingFee: "Taxa de processamento",
    totalToPay: "Total a pagar",
    paid: "Pago",
    pending: "Pendente",
    failed: "Falhou",
    canceled: "Cancelado",
    accountSigned: "Conta Assinada",
    card: "Cartão",
    cardNumberPlaceholder: "Número do cartão",
    cardHolderPlaceholder: "Nome no cartão",
    cardExpMonthPlaceholder: "Mês (MM)",
    cardExpYearPlaceholder: "Ano (AA)",
    cardCvvPlaceholder: "CVV",
    cardSecurityNote: "Seus dados são criptografados e não são armazenados.",
    payAmount: "Pagar R$ {amount}",
    pixScanOrCopy: "Escaneie o QR Code ou copie o código PIX",
    successTitle: "Pagamento confirmado!",
    successMessage: "Seu pagamento foi aprovado. Obrigado!",
    errorProcessing: "Erro ao processar pagamento"
  },
  reservation: {
    individual: "Individual",
    multipleResponsible: "Múltiplos Responsáveis",
    closedOrganizer: "Fechada - Organizador",
    closedNonOrganizer: "Fechada - Não Organizador",
    values: "Valores",
    details: "Detalhes da Reserva",
    backToSelection: "Voltar para seleção de reserva"
  },
  reservations: {
    title: "Reservas",
    new: "Nova Reserva",
    newReservation: "Nova Reserva",
    edit: "Editar Reserva",
    delete: "Excluir Reserva",
    client: "Cliente",
    service: "Serviço",
    date: "Data",
    time: "Horário",
    status: "Status",
    notes: "Observações",
    confirmed: "Confirmada",
    pending: "Pendente",
    cancelled: "Cancelada",
    completed: "Concluída",
    selectType: "Selecione o tipo de reserva",
    selectReservationType: "Selecione o tipo de reserva",
    loggedAs: "Logado como:",
    individual: "Individual",
    individualDescription: "Reserva para 1 pessoa. Pagamento imediato do valor total.",
    multiple: "Múltipla (Responsável)",
    multipleDescription: "Quantidade > 1. Links de convite para pagamento individual.",
    closedNonOrganizer: "Fechada (Não Organizador)",
    closedNonOrganizerDescription: "Idêntico ao múltiplo: links + cadastro + termo + pagamento individual.",
    closedOrganizer: "Bateria Fechada – Organizador",
    closedOrganizerDescription: "Links + cadastro + termo; sem cobrança no momento."
  }
};

// EN translations
const enTranslations = {
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    clear: "Clear",
    select: "Select",
    all: "All",
    none: "None",
    yes: "Yes",
    no: "No",
    tryAgain: "Try Again",
    continue: "Continue",
    finish: "Finish"
  },
  navigation: {
    home: "Home",
    reservations: "Reservations",
    clients: "Clients",
    services: "Services",
    reports: "Reports",
    settings: "Settings",
    profile: "Profile",
    logout: "Logout"
  },
  settings: {
    title: "Settings",
    theme: "Theme",
    language: "Language",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    preferences: "Preferences",
    account: "Account",
    notifications: "Notifications",
    privacy: "Privacy",
    security: "Security"
  },
  auth: {
    login: "Login",
    logout: "Logout",
    register: "Register",
    newAccount: "New Account",
    resetPassword: "Reset Password",
    resetPasswordInstructions: "Enter your email to receive a password reset link",
    // {|INICIO| 23/07/2026 às 02:58 - ETAPA 7: ALIGN RESET MESSAGES WITH NEUTRAL RESPONSE AND 30-MIN TTL}
    resetPasswordNote: "If an account exists for this email, we will send a reset link valid for 30 minutes.",
    fullName: "Full Name",
    enterFullName: "Enter your full name",
    cpf: "CPF",
    cpfPlaceholder: "000.000.000-00",
    birthDate: "Birth Date",
    cellPhone: "Cell Phone",
    phonePlaceholder: "(11) 99999-9999",
    email: "Email",
    enterEmail: "your@email.com",
    password: "Password",
    enterPassword: "Enter your password",
    processing: "Processing...",
    sending: "Sending...",
    send: "Send",
    noAccount: "Don't have an account? Sign up",
    hasAccount: "Already have an account? Login",
    forgotPassword: "Forgot your password?",
    emailSentSuccess: "Request received successfully!",
    checkInboxSpam: "Check your inbox and spam folder. The link expires in 30 minutes.",
    // {|FIM| 23/07/2026 às 02:58 - ETAPA 7: ALIGN RESET MESSAGES WITH NEUTRAL RESPONSE AND 30-MIN TTL}
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    enterEmailToReset: "Enter your email to reset password",
    checkEmailForReset: "Check your email for password reset information.",
    loginSuccessful: "Login successful!",
    loginFailed: "Login failed",
    resetPasswordFailed: "Failed to send password reset",
    emailPlaceholder: "Your email",
    passwordPlaceholder: "Your password",
    loggingIn: "Logging in...",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    enterNewPassword: "Enter your new password",
    enterNewPasswordBelow: "Enter your new password below",
    passwordStrength: "Password strength",
    passwordRequirements: "Password requirements",
    passwordMinLength: "At least 8 characters",
    passwordUpperCase: "One uppercase letter",
    passwordLowerCase: "One lowercase letter",
    passwordNumber: "One number",
    passwordsDoNotMatch: "Passwords do not match",
    passwordChangedSuccess: "Password changed successfully!",
    passwordChangeError: "Error changing password!",
    requestProcessingError: "Error processing request",
    tokenNotFound: "Token not found!",
    tokenInvalidOrExpired: "Invalid or expired token! Request a new password reset.",
    tokenVerificationError: "Error verifying token. Please try again.",
    verifyingToken: "Verifying token...",
    invalidToken: "Invalid Token",
    backToLogin: "Back to Login",
    enterEmailForReset: "Please enter your email to recover your password"
  },
  terms: {
    title: "Terms of Responsibility",
    loadError: "Error loading terms of responsibility",
    mustAcceptToContinue: "You must check that you have read and accept the terms to continue",
    acceptError: "Error accepting terms",
    loading: "Loading terms of responsibility...",
    downloadPdf: "Download PDF",
    acceptanceText: "I have read and fully accept the <strong>Terms of Responsibility</strong> of {companyName}, being aware of all risks, obligations and conditions established.",
    accepting: "Accepting...",
    acceptAndContinue: "Accept and Continue",
    mandatory: "Terms of Responsibility",
    requiredForPayment: "Acceptance of the Terms of Responsibility is required to proceed with payment.",
    updatedAcceptanceRequired: "The Terms of Responsibility have been updated. Please read and accept the new version to continue."
  },
  examples: {
    changePasswordExample: "Change Password Example",
    enterClientId: "Enter Client ID",
    clientId: "Client ID",
    enterClientIdPlaceholder: "Enter the client ID",
    clientIdRequired: "Please enter the client ID",
    invalidClientId: "Invalid client ID",
    passwordChangedSuccess: "Password changed successfully!",
    clientIdLabel: "Client ID"
  },
  registration: {
    fullName: "Full Name",
    enterFullName: "Enter your full name",
    email: "Email",
    enterEmail: "Enter your email",
    birthDate: "Date of Birth",
    cellPhone: "Cell Phone",
    enterPhone: "Enter your phone",
    register: "Register",
    registering: "Registering...",
    fullNameRequired: "Please enter your full name (first and last name). Avoid abbreviations.",
    invalidCpf: "The CPF entered is invalid!",
    invalidEmail: "Please enter a valid email.",
    birthDateRequired: "Date of birth is required.",
    invalidPhone: "Please enter a valid cell phone number. For Brazilian numbers: (11) 91234-5678. For international numbers: +55 11 91234-5678",
    country: "Country",
    selectCountry: "Select your country",
    cpf: "CPF",
    passport: "Passport",
    enterCpf: "Enter your CPF",
    enterPassport: "Enter your passport number",
    invalidPassport: "Invalid passport number"
  },
  profile: {
    header: "MY REGISTRATION",
    identification: "Identification",
    id: "ID",
    clientType: "Client Type",
    consumerFinal: "Final Consumer",
    other: "Other",
    origin: "Origin",
    notProvided: "Not provided",
    personalDataProtected: "Personal Data (Protected)",
    securityNote: "Name, Country, CPF/Passport and Email cannot be changed for security reasons.",
    name: "Name",
    country: "Country",
    cpf: "CPF",
    passport: "Passport",
    email: "Email",
    birthDate: "Birth Date",
    rg: "ID Document",
    gender: "Gender",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",
    contactEditable: "Contact (Editable)",
    mobilePhone: "Mobile Phone",
    homePhone: "Home Phone",
    workPhone: "Work Phone",
    guardianDataMinor: "Guardian Data (Minor)",
    guardianName: "Guardian Name",
    guardianCpf: "Guardian CPF",
    guardianPhone: "Guardian Phone",
    addressEditable: "Address (Editable)",
    zipCode: "ZIP Code",
    address: "Address",
    number: "Number",
    complement: "Complement",
    neighborhood: "Neighborhood",
    state: "State",
    city: "City",
    saveChanges: "Save Changes",
    editProfile: "Edit Profile",
    updateSuccess: "Profile updated successfully!",
    updateError: "Error saving profile. Please try again.",
    protectedField: "Protected field - cannot be changed",
    protectedByRegistration: "Protected by registration",
    typeZipToSearch: "Type ZIP to automatically search address"
  },
  app: {
    title: "{companyName}",
    subtitle: "Online Reservation System",
    welcome: "Welcome",
    myReservations: "My Reservations",
    changePassword: "Change Password",
    loading: "Loading...",
    noReservationsFound: "No reservations found in this category",
    people: "People",
    type: "Type",
    location: "Location",
    time: "Time",
    value: "Value Paid",
    date: "Date",
    individual: "Individual",
    group: "Group",
    payNow: "Pay Now",
    manageParticipants: "Manage Participants",
    cancel: "Cancel",
    cancelled: "Cancelled",
    paid: "Paid",
    pending: "Pending",
    failed: "Failed",
    canceled: "Canceled",
    accountSigned: "Signed Account",
    openBatteries: "Open Batteries",
    closedBatteries: "Closed Batteries",
    viewDetails: "View Details",
    acceptTerms: "Accept Terms",
    cancelReservation: "Cancel Reservation",
    consultPoints: "Consult Points",
    newRegistration: "New Registration",
      myProfile: "My Profile",
      selectDate: "Select Date",
      availableSlots: "Available Slots",
      noCharge: "No Charge",
      organizerOnly: "Option available only for organizers",
      terms: {
      mandatoryAcceptance: "Mandatory Acceptance of Terms of Responsibility",
      acceptanceRequired: "To proceed with your reservation, you must read and accept the terms of responsibility of {companyName}. The term is valid for {days} days.",
      readFullTerm: "Read Full Terms"
    },
    contactForOrganizerPermissions: "Contact us to request organizer permissions",
    noSlotsAvailable: "No slots available for this date",
    loginRequired: "Login required to make a reservation",
    loginToReserve: "To reserve, please login",
    slotUnavailable: "Slot unavailable",
    reserve: "Reserve",
    points: "Points",
    expiresOn: "Expires on",
    remainingDays: "Remaining Days",
    total: "TOTAL",
    noPointsAvailable: "No points available to display.",
    loadingPoints: "Loading...",
    userNotFound: "User not found. Please login again.",
    pointsLoadError: "Error loading points statement. Please try again.",
    currentPasswordRequired: "Current password is required",
    newPasswordRequired: "New password is required",
    passwordsDoNotMatch: "New password and confirmation do not match",
    passwordMinLength: "New password must be at least 6 characters",
    changePasswordError: "Error changing password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changing: "Changing...",
    generating: "Generating...",
    generate: "Generate",
    error: "Error",
    status: {
      disponível: "Disponível",
      indisponível: "No disponible",
      ocupado: "Ocupado",
      reservado: "Reservado"
    },
    slots: "Slots",
    reservationNumber: "Reservation #{id}",
    unitValueLabel: "Unit Value",
    totalLabel: "Total",
    updatingStatus: "Updating status...",
    retryPayment: "Make New Payment",
    cancelConfirmTitle: "Confirm Cancellation",
    cancelIrreversibleNote: "This action is irreversible",
    cancelReservationQuestion: "Are you sure you want to cancel this reservation?",
    cancelPolicyTitle: "Cancellation Policy",
    cancelPolicyDescription: "Cancellation will be processed according to KGV policies. For refund questions, contact {phone}."
  },
  calendar: {
    selectDate: "Select Date",
    timeExpired: "Time already passed",
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December"
    },
    days: {
      sunday: "Sun",
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat"
    },
    selected: "Selected",
    unavailable: "Unavailable"
  }
};
*/

export type Language = 'pt' | 'en' | 'es';

interface LanguageContextType {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const translations: Record<Language, any> = {
  pt: ptJson as any,
  en: enJson as any,
  es: esJson as any,
};

// {|INICIO| 02/04/2026 às 10:14 - LINT: FUNÇÃO NÃO UTILIZADA (MANTER COMO UTIL INTERNO)}
const _detectBrowserLanguage = (): Language => {
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('pt')) return 'pt';
  if (browserLang.startsWith('es')) return 'es';
  return 'en';
};
// {|FIM| 02/04/2026 às 10:14 - LINT: FUNÇÃO NÃO UTILIZADA (MANTER COMO UTIL INTERNO)}

interface LanguageProviderProps {
  children: React.ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(() => {
    const savedLanguage = localStorage.getItem('language') as Language;
    if (savedLanguage && (savedLanguage === 'pt' || savedLanguage === 'en' || savedLanguage === 'es')) {
      return savedLanguage;
    }
    return 'pt';
  });

  const setLanguage = (newLanguage: Language) => {
    setLanguageState(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  /**
   * Traduz uma chave e substitui placeholders no formato {param}.
   */
  const t = (key: string, params?: Record<string, string | number>): string => {
    const getNestedValue = (obj: any, path: string): any => {
      return path.split('.').reduce((current, k) => {
        return current && current[k] !== undefined ? current[k] : null;
      }, obj);
    };

    let translation = getNestedValue(translations[language], key) ?? getNestedValue(translations['pt'], key) ?? key;
    if (typeof translation !== 'string') translation = String(translation);

    // {|INICIO| 20/03/2026 às 11:20 - INJEÇÃO AUTOMÁTICA DE companyName NO i18n VIA VITE_APP_TITLE}
    const envAny = import.meta.env as unknown as { readonly [key: string]: string | boolean | undefined };
    const companyNameFromEnv = envAny['VITE_APP_TITLE'];
    // {|INICIO| 22/06/2026 às 15:50 - AJUSTAR NOME PADRÃO DA EMPRESA PARA KARTÓDROMO GRANJA VIANA NO I18N}
    const companyName =
      (typeof companyNameFromEnv === 'string' && companyNameFromEnv.trim() ? companyNameFromEnv.trim() : null) ||
      'Kartódromo Granja Viana';
    // {|FIM| 22/06/2026 às 15:50 - AJUSTAR NOME PADRÃO DA EMPRESA PARA KARTÓDROMO GRANJA VIANA NO I18N}
    const companyNameUpper = companyName.toUpperCase();

    const mergedParams: Record<string, string | number> = {
      companyName,
      companyNameUpper,
      ...(params || {}),
    };

    Object.entries(mergedParams).forEach(([paramKey, paramValue]) => {
      translation = translation.split(`{${paramKey}}`).join(String(paramValue));
    });
    // {|FIM| 20/03/2026 às 11:20 - INJEÇÃO AUTOMÁTICA DE companyName NO i18n VIA VITE_APP_TITLE}

    return translation;
  };

  const value = {
    language,
    setLanguage,
    t,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
